export const sanitizeLastName = (lastName: string | null): string => {
  return lastName || '.';
};
